var include_top_shop = `
<div class="top-shop js-minheight__controll">
    <div class="top-shop__inner">
        <div class="top-shop__logo"><img src="/material/img/top/img_top_shop01.png" alt="shop"></div>
        <p class="top-shop__title">使えるお店、拡大中！</p>
        <p class="align-center mt20">nanacoが使えるお店は<span class="text-emphasis text-emphasis--fs22">125万店</span>を突破！</p>
        <div class="shop-wrap">
            <div class="shop-wrap__content">
                <div class="shop-add">
                    <div class="shop-add__header">
                        <p class="shop-add__title">NEW!</p>
                        <p class="shop-add__text">nanacoが使えるようになりました</p>
                    </div>
                    <div class="shop-add__content">
                        <ul class="shop-add__list">
                            <li class="shop-add__list-item"><img src="/material/img/common/logo/logo_xebio.png" alt="スーパースポーツゼビオ"></li>
                            <li class="shop-add__list-item"><img src="/material/img/common/logo/logo_victoria.png" alt="ヴィクトリア"></li>
                            <li class="shop-add__list-item align-center"><img src="/material/img/common/logo/logo_victoria_golf.png" alt="ヴィクトリアゴルフ"></li>
                            <li class="shop-add__list-item align-center"><img src="/material/img/common/logo/logo_l_breath.png" alt="エルブレス"></li>
                        </ul>
                    </div>
                </div>
                <div class="grid-wrapper mt45">
                    <div class="grid grid--logos">
                        <div class="grid-item">
                            <div class="shop-logo"><img src="/material/img/common/logo/logo_eneos.png" alt="ENEOS"></div>
                        </div>
                        <div class="grid-item">
                            <div class="shop-logo"><img src="/material/img/common/logo/logo_loft.png" alt="LOFT"></div>
                        </div>
                        <div class="grid-item">
                            <div class="shop-logo"><img src="/material/img/common/logo/logo_shimamura.png" alt="しまむら"></div>
                        </div>
                        <div class="grid-item">
                            <div class="shop-logo"><img src="/material/img/common/logo/logo_mcdonalds.png" alt="マクドナルド"></div>
                        </div>
                        <div class="grid-item">
                            <div class="shop-logo"><img src="/material/img/common/logo/logo_mister_donut.png" alt="mister Donut"></div>
                        </div>
                        <div class="grid-item">
                            <div class="shop-logo"><img src="/material/img/common/logo/logo_yoshinoya.png" alt="吉野家"></div>
                        </div>
                        <div class="grid-item">
                            <div class="shop-logo"><img src="/material/img/common/logo/logo_ichibanya.png" alt="coco壱番屋"></div>
                        </div>
                        <div class="grid-item">
                            <div class="shop-logo"><img src="/material/img/common/logo/logo_tsuruhagroup.png" alt="ツルハグループ"></div>
                        </div>
                        <div class="grid-item">
                            <div class="shop-logo"><img src="/material/img/common/logo/logo_biccamera.png" alt="ビックカメラ"></div>
                        </div>
                        <div class="grid-item">
                            <div class="shop-logo"><img src="/material/img/common/logo/logo_ohsho.png" alt="餃子の王将"></div>
                        </div>
                        <div class="grid-item">
                            <div class="shop-logo"><img src="/material/img/common/logo/logo_hanamaru.png" alt="はなまる"></div>
                        </div>
                        <div class="grid-item">
                            <div class="shop-logo"><img src="/material/img/common/logo/logo_sugi.png" alt="くすりスギ薬局"></div>
                        </div>
                        <div class="grid-item">
                            <div class="shop-logo"><img src="/material/img/common/logo/logo_taito.png" alt="GAME TAITO STATION"></div>
                        </div>
                        <div class="grid-item">
                            <div class="shop-logo"><img src="/material/img/common/logo/logo_kaikatsu-club.png" alt="快活CLUB"></div>
                        </div>
                        <div class="grid-item">
                            <div class="shop-logo"><img src="/material/img/common/logo/logo_cocokarafine.png" alt="ココカラファイン ココロ、カラダ、ゲンキ"></div>
                        </div>
                        <div class="grid-item">
                            <div class="shop-logo"><img src="/material/img/common/logo/logo_sundrug.png" alt="サンドラッグ"></div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="shop-wrap__thumbnail pc-only"><img src="/material/img/top/img_top_shop02.png" alt=""></div>
        </div>
        <div class="mt50 align-center">
            <div class="btn-link__wrap">
                <a href="/alliance/" class="btn-link btn-link--rainbow Nanaco_TopShop"><span class="btn-link__text">使えるお店を探す</span></a>
            </div>
        </div>
    </div>
</div>
`;
